import { InjectedConnector } from "@web3-react/injected-connector"
import { ChainIds } from "@hfc/shared/typings/blockchain/Network"

export const injected = new InjectedConnector({
	supportedChainIds: [ChainIds.polygon],
})
